export const FORM_LABELS = require('./FORM_LABELS').default
export const FORM_OPTIONS = require('./FORM_OPTIONS').default
export const FORM_DATA = require('./FORM_DATA')
export const PAYEE = require('./PAYEE')
export const SUBSCRIPTION = require('./SUBSCRIPTION')

// hostname
export const HOSTNAME = {
  DEM: 'store-demo.agaru.tv',
  DEV: 'dev.uranai.tv',
  STG: 'stg.uranai.tv',
  PRD: 'www.uranai.tv'
}

export const ACCOUNT_DOMAIN = {
  LCL: 'http://local-reserve.uranaifes.com',
  DEM: 'https://dev-reserve.uranaifes.com',
  DEV: 'https://dev-reserve.uranaifes.com',
  STG: 'https://dev-reserve.uranaifes.com',
  PRD: 'https://reserve.uranaifes.com'
}

// 書式関連
export const FORMAT = {
  DATE: 'YYYY/M/D',
  TIME: 'HH:mm',
  DATETIME: 'YYYY/M/D HH:mm'
}

export const BIRTHTIME_UNKNOWN_VALUE = '9999'

//ダイアログステータス
export const DIALOG_STAT = {
  disable: 0,
  show: 1
}



// WEBPACK FOOTER //
// ./resources/assets/js/CONSTS/index.js